var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconCareers18 = function SvgAIconCareers18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10V13",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.5C6 2.39543 6.89543 1.5 8 1.5H10C11.1046 1.5 12 2.39543 12 3.5V5H6V3.5Z",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.5C1 5.67157 1.67157 5 2.5 5H15.5C16.3284 5 17 5.67157 17 6.5V8C17 9.65685 15.6569 11 14 11H9H4C2.34315 11 1 9.65685 1 8V6.5Z",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10V15C1.5 15.8284 2.17157 16.5 3 16.5H15C15.8284 16.5 16.5 15.8284 16.5 15V10",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
};
export { SvgAIconCareers18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik05IDEwVjEzIiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNNiAzLjVDNiAyLjM5NTQzIDYuODk1NDMgMS41IDggMS41SDEwQzExLjEwNDYgMS41IDEyIDIuMzk1NDMgMTIgMy41VjVINlYzLjVaIiBzdHJva2Utd2lkdGg9IjEuMyIgLz4KPHBhdGggZD0iTTEgNi41QzEgNS42NzE1NyAxLjY3MTU3IDUgMi41IDVIMTUuNUMxNi4zMjg0IDUgMTcgNS42NzE1NyAxNyA2LjVWOEMxNyA5LjY1Njg1IDE1LjY1NjkgMTEgMTQgMTFIOUg0QzIuMzQzMTUgMTEgMSA5LjY1Njg1IDEgOFY2LjVaIiBzdHJva2Utd2lkdGg9IjEuMyIgLz4KPHBhdGggZD0iTTEuNSAxMFYxNUMxLjUgMTUuODI4NCAyLjE3MTU3IDE2LjUgMyAxNi41SDE1QzE1LjgyODQgMTYuNSAxNi41IDE1LjgyODQgMTYuNSAxNVYxMCIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KPC9zdmc+";